if (!window.SwymCallbacks) window.SwymCallbacks = [];
window.SwymCallbacks.push(initSwymUI);

let swat;
let settings;
let sectionId;
let elements;

function initSwymUI(swatInstance) {
  swat = swatInstance;
  const wishlistElement = document.querySelector('.swymcs-custom-wishlist');
  settings = JSON.parse(wishlistElement.dataset.settings);
  sectionId = wishlistElement.dataset.sectionid;

  elements = {
    loader: wishlistElement.querySelector('#swymcs-wishlist-loader'),
    container: wishlistElement.querySelector('#swymcs-wishlist-container'),
    listOptions: wishlistElement.querySelector('#swymcs-wishlist-list-options-container'),
    itemsContainer: wishlistElement.querySelector('#swymcs-wishlist-items-container'),
    emptyContainer: wishlistElement.querySelector('#swymcs-empty-wishlist-container'),
  };

  fetchWishlist();
}

function fetchWishlist() {
  showLoader();
  swat.fetchLists({
    callbackFn: (lists) => {
      lists = lists.reverse(); //Display lists in order of most recent creation
      swat.swymCustomWishlistLists = lists;

      const currentListId = swat.swymCustomWishlistSelectedListId || lists[0]?.lid;
      swat.swymCustomWishlistSelectedListId = currentListId;

      const selectedList = lists.find(({ lid }) => lid === currentListId) || lists[0]; 
      
      if (swat.isCollectionsEnabled()) 
        renderMultipleListOptions(lists);
        if(selectedList){
          renderList(selectedList.listcontents);
        } else {  
          updateUIState(lists);
        }
    },
    errorFn: (error) => console.error('Error while fetching all Lists', error),
  });
}


async function renderList(list) {
  elements.itemsContainer.innerHTML = '';
  if (list.length > 0) {
    const wishlistedProducts = await fetchProductData(list);
    wishlistedProducts.forEach(renderWishlistItem);
  }
  updateUIState(list);
}

async function fetchProductData(wishlist) {
  const productDataPromises = wishlist.map(async (listItem) => {
    const response = await fetch(`${listItem.du.split('?')[0]}.js`);
    listItem.productData = await response.json();
    return listItem;
  });
  return await Promise.all(productDataPromises);
}


function renderMultipleListOptions(lists) {
  if (lists.length > 1) {
    const listOptionsHtml = lists.map(({ lid, lname, listcontents }) => `
          <option class="swymcs-wishlist-list-option" value="${lid}" ${lid === swat.swymCustomWishlistSelectedListId ? 'selected' : ''}>
            ${lname} (${listcontents.length} items)
          </option>`).join('');
    elements.listOptions.innerHTML = `
          <select class="swymcs-wishlist-list" id="swym-mutliple-list" onchange="onListChange(event)">
            ${listOptionsHtml}
          </select>
        `;
  }
}

function onListChange(event) {
    swat.swymCustomWishlistSelectedListId = event.target.value;
  const selectedList = swat.swymCustomWishlistLists.find(({ lid }) => lid === event.target.value);
  renderList(selectedList.listcontents);
}

function renderWishlistItem(item) {
  const wishlistItem = document.createElement('div');
  wishlistItem.classList.add('swiper-slide', 'grid__item', 'swymcs-wishlistplus-item');
  wishlistItem.dataset.epi = item.epi;
  wishlistItem.dataset.empi = item.empi;
  wishlistItem.dataset.du = item.du;
  wishlistItem.dataset.sectionid = sectionId;

  const productImage = item.productData?.featured_image || item.iu;
  const secondProductImage = item.productData?.images[1] || item.productData?.featured_image || item.iu;
  const productComPrice = item.productData.compare_at_price;
  const selectedVariant = item.productData.variants.find(variant => variant.id == item.epi);
  const isInCart = _swat.platform.isInDeviceCart(selectedVariant.id);
  const getButtonState = () => selectedVariant?.available ? (isInCart ? settings.swym_wishlist_item_cta_addedtocart : settings.swym_wishlist_item_cta_addtocart) : settings.swym_wishlist_item_cta_soldout;
  
  
  wishlistItem.innerHTML = `
   <div class="product-slide-block">
     <div class="card-wrapper product-card-wrapper">
       <div class="card card--standard card--media" style="--ratio-percent: 100.0%;">
         <div class="card__inner color-scheme-1 gradient ratio">
          ${secondProductImage ?
          ` <div class="card__media-hover">
            <img src="${productImage}" width="70" height="70" loading="lazy" />
            <img src="${secondProductImage}" width="70" height="70" loading="lazy" />
          </div>
          ` : `` }
          <div class="card__media">
           <div class="media media--transparent media--hover-effect">
            <img src="${productImage}" class="swymcs-wishlistplus-item-image" loading="lazy" />
            ${secondProductImage ?
            ` <img src="${secondProductImage}" class="swymcs-wishlistplus-item-image" loading="lazy" />
            ` : `` }
           </div>   
          </div>
          <div class="card__content">
             <div class="card__badge top right">
              ${!selectedVariant?.available ? `
                <span class="badge badge--bottom-left color-scheme-3 sold-badge text-uppercase">${window.variantStrings.badge_sold_out}</span>
              ` : ''}
             </div>
             <a href="${item.du}" class="overlay-link">${item.dt}</a>
          </div>
        </div>
        <div class="card__content swymcs-wishlistplus-item-content">
         <div class="card__information">
          <h3 class="card__heading h5">
            <a href="${item.du}" class="full-unstyled-link swymcs-wishlistplus-item-title">
              <div class="swymcs-wishlistplus-item-title-content">${item.dt}</div>
            </a>
          </h3>
         </div> 
         <div class="card-information">
           <span class="caption-large light"></span>
           <div class="price ${productComPrice ? `price--on-sale` : `` } price--show-badge swymcs-product-final-price">
            <div class="price__container"> 
             <div class="price__regular">
              ${Shopify.formatMoney(selectedVariant.price)}
             </div>
             <div class="price__sale"> 
               <div class="price-item price-item--sale price-item--last">
                ${Shopify.formatMoney(selectedVariant.price)}
               </div>
               <span>
                <s class="price-item price-item--regular">
                 ${Shopify.formatMoney(selectedVariant.compare_at_price)}
                </s>
              </span>
             </div>    
            </div>     
           </div>
          </div>
          <div class="swymcs-wishlist-action-container">
            ${selectedVariant?.available ? `
              <product-form data-section-id="{{ section.id }}">
                <form method="post" action="/cart/add" id="quick-add-template--${selectedVariant.id}__featured_collection_ddTz378496877011282" accept-charset="UTF-8" class="form" enctype="multipart/form-data" novalidate="novalidate" data-type="add-to-cart-form">
                  <input type="hidden" name="id" value="${selectedVariant.id}" class="product-variant-id">
                  <button id="{{ product_form_id }}-submit" type="submit" name="add" class="quick-add__submit button button--full-width text-uppercase text-center" aria-haspopup="dialog" aria-live="polite" data-sold-out-message="true">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" class="icon icon-cart"><path d="M15.4167 6.04167H13.5417V5.41667C13.5417 3.46333 11.9534 1.875 10 1.875C8.04671 1.875 6.45837 3.46333 6.45837 5.41667V6.04167H4.58337C3.55004 6.04167 2.70837 6.8825 2.70837 7.91667V15C2.70837 17.015 3.81837 18.125 5.83337 18.125H14.1667C16.1817 18.125 17.2917 17.015 17.2917 15V7.91667C17.2917 6.8825 16.45 6.04167 15.4167 6.04167ZM7.70837 5.41667C7.70837 4.1525 8.73587 3.125 10 3.125C11.2642 3.125 12.2917 4.1525 12.2917 5.41667V6.04167H7.70837V5.41667ZM16.0417 15C16.0417 16.3142 15.4809 16.875 14.1667 16.875H5.83337C4.51921 16.875 3.95837 16.3142 3.95837 15V7.91667C3.95837 7.57167 4.23921 7.29167 4.58337 7.29167H6.45837V9.16667C6.45837 9.51167 6.73837 9.79167 7.08337 9.79167C7.42837 9.79167 7.70837 9.51167 7.70837 9.16667V7.29167H12.2917V9.16667C12.2917 9.51167 12.5717 9.79167 12.9167 9.79167C13.2617 9.79167 13.5417 9.51167 13.5417 9.16667V7.29167H15.4167C15.7609 7.29167 16.0417 7.57167 16.0417 7.91667V15Z" fill="white"></path></svg>
                    <span class="hover_text">
                      ${window.variantStrings.addToCart}
                    </span>
                    <div class="loading__spinner hidden">
                      <svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg" height="30px" width="30px">
                        <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
                      </svg>
                    </div>
                  </button>
                </form>  
              </product-form>  
            ` : ''}
            ${!selectedVariant?.available ? `
              <a href="${item.du}" class="quick-add__submit button button--full-width text-uppercase text-center" aria-haspopup="dialog">
                <span>${window.variantStrings.soldOut}</span>
              </a>
            ` : ''}
          </div>
        </div>
        ${settings.swym_wishlist_show_delete_item ? `<button id="swymcs-remove-productBtn" aria-label="Delete" class="swymcs-wishlistplus-item-remove"><svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="-5.0 -10.0 110.0 135.0"> <g> <path d="m76.801 28.898h-53.602c-0.5 0-1 0.19922-1.3008 0.60156-0.30078 0.39844-0.5 0.89844-0.5 1.3008l4 49.199c0 4.6016 3.8008 8.3984 8.3984 8.3984h32.199c4.6016 0 8.3984-3.6992 8.3984-8.3984l4-49.199c0-0.5-0.10156-1-0.5-1.3008-0.19531-0.39844-0.59375-0.60156-1.0938-0.60156zm-5.8008 50.902v0.10156c0 2.6992-2.1992 4.8984-4.8984 4.8984h-32.199c-2.6992 0-4.8984-2.1992-4.8984-4.8984v-0.10156l-3.8984-48.602h49.898zm0 0" fill="#c02827"/> <path d="m88 10.098h-21.801v-5.8008c0-2.6992-2.1992-4.8984-4.8984-4.8984h-22.398c-2.6992 0-4.8984 2.1992-4.8984 4.8984v5.8008h-21.801c-1.6992 0-3 1.3008-3 3s1.3008 3 3 3h75.801c1.6992 0 3-1.3008 3-3s-1.3008-3-3-3zm-30.602 0h-19.801v-5.8008c0-1.1992 1-2.1992 2.1992-2.1992h15.602c1.1992 0 2.1992 1 2.1992 2.1992zm0 0" fill="#c02827"/> <path d="m59.102 30.5c-1.6992 0-3 1.3008-3 3v35.301c0 1.6992 1.3008 3 3 3s3-1.3008 3-3v-35.301c0-1.6992-1.3008-3-3-3zm-18.398 0c-1.6992 0-3 1.3008-3 3v35.301c0 1.6992 1.3008 3 3 3s3-1.3008 3-3v-35.301c0-1.6992-1.3008-3-3-3zm0 0" fill="#c02827"/> </g> </svg></button>` : ''}
        </div>
      </div>
    </div>`;

  wishlistItem.querySelector('[data-action="add-to-cart"]')?.addEventListener('click', (event) => {
    event.preventDefault();
    let button = event.target;

    let { empi, epi, du, qty } = item;

    let originalButtonState = button.innerHTML;
    button.innerHTML = settings.swym_wishlist_item_cta_addingtocart;

    swat.replayAddToCart(
        { empi: empi, du: du, qty: qty},epi,
        (success) => {
          button.innerHTML = settings.swym_wishlist_item_cta_addedtocart;
          const variant = JSON.parse(success).items[0];
          const productTitle = variant.title;
          let successMessage = `<strong>${productTitle}</strong> has been added to cart!`;
          swat.ui.showSuccessNotification({ message:successMessage }); 
        },
        (error) => {
          button.innerHTML = originalButtonState;
          swat.ui.showErrorNotification({ message: error.description });
        }
      );
  });

  wishlistItem.querySelector('#swymcs-remove-productBtn')?.addEventListener('click', () => {
    let product = {
      epi: item.epi,
      empi: item.empi,
      du: item.du
    }
    _swat.deleteFromList(_swat.swymCustomWishlistSelectedListId, product, ()=>{ fetchWishlist() }, (error) => console.error('Failed to remove from wishlist', error));
  });

  elements.itemsContainer.appendChild(wishlistItem);
}

function updateUIState(wishlist) {
  hideLoader();
  if (wishlist.length > 0) {
    elements.container.classList.remove('swymcs-hide-container');
    elements.emptyContainer.classList.add('swymcs-hide-container');
  } else {
    elements.emptyContainer.classList.remove('swymcs-hide-container');
    elements.container.classList.add('swymcs-hide-container');
  }
}

function showLoader() {
  elements.loader.classList.remove('swymcs-hide-container');
}

function hideLoader() {
  elements.loader.classList.add('swymcs-hide-container');
}